// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_V1O","cls2":"WorkCard-cls2_DcR WorkCard-cls1_V1O"};